/* TagsColumnRenderer.js */

"use strict";

const _ = require("lodash");

class TagsColumnRenderer {
    constructor(model) {
        this._model = model;
        this._rootElem = document.createElement("tags-column");
        this._rootElem.component = this._model;

        this._registerListeners();
        this.render();
    }
    /********************************************/
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/
    _shutdown() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._unregisterListeners();
            this._model = undefined;
            this._rootElem.remove();
            this._rootElem = undefined;
            resolve();
        });
        return prom;
    }
    _registerListeners() {
        this._model.on("DisplayTags", (this._onDisplayTags = this._onDisplayTags.bind(this)));
    }
    _unregisterListeners() {
        this._model.removeListener("DisplayTags", this._onDisplayTags);
    }
    /*******************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS  */
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    /**
     * Stateless method to completely rebuild this component from the _rootElem down.
     * @returns {Promise} An ES6 promise that lets the caller know when the component has finished rendering. If a non
     * Promise is returned the caller will assume the Renderer has completed rendering.
     */
    render() {
        let prom = new Promise((resolve /*,reject*/) => {
            this._setDisplayTags(this._model.getDisplayTags());
            resolve();
        });
        return prom;
    }
    get rootElement() {
        return this.getRootElement();
    }
    getRootElement() {
        return this._rootElem;
    }
    get model() {
        return this.getModel();
    }
    getModel() {
        return this._model;
    }
    /*******************************************/
    /* END COMPONENT RENDERER METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /**
     * Fired when the tags have been updated in the model
     * @param newVal {Boolean}
     * @private
     */
    _onDisplayTags(newVal) {
        this._setDisplayTags(newVal);
    }

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    /**
     * Set the tags in the HTML
     * @param newVal {Boolean}
     * @private
     */
    _setDisplayTags(newVal) {
        if (!_.isUndefined(newVal)) {
            this._rootElem.innerHTML = newVal;
        } else {
            this._rootElem.innerHTML = "";
        }
    }

    /*******************************************/
    /*  END PRIVATE API METHODS */
    /*******************************************/
}

module.exports = TagsColumnRenderer;
